import React from "react";
import { Tooltip, makeStyles } from "@material-ui/core";
import WhatsAppIcon from "@material-ui/icons/WhatsApp";
import TelegramIcon from "@material-ui/icons/Telegram";

const useStyles = makeStyles(() => ({
  "@keyframes channelPop": {
    "0%": { transform: "scale(0.4)", opacity: 0 },
    "60%": { transform: "scale(1.2)", opacity: 1 },
    "100%": { transform: "scale(1)" },
  },
  "@keyframes channelWiggle": {
    "0%, 100%": { transform: "rotate(0deg) scale(1.15)" },
    "25%": { transform: "rotate(-12deg) scale(1.15)" },
    "75%": { transform: "rotate(12deg) scale(1.15)" },
  },
  icon: {
    display: "inline-flex",
    flexShrink: 0,
    borderRadius: "50%",
    animation: "$channelPop 0.45s ease-out both",
    transition: "filter 0.2s ease",
    "&:hover, .channel-hover:hover &": {
      animation: "$channelWiggle 0.5s ease-in-out",
      filter: "drop-shadow(0 0 4px currentColor)",
    },
    "@media (prefers-reduced-motion: reduce)": {
      animation: "none !important",
    },
  },
}));

export const getCampaignChannel = (campaign) => {
  const whatsapp = campaign?.whatsapp || {};
  const type = String(whatsapp.type || whatsapp.channel || "").toLowerCase();
  return campaign?.origin === "bot" || type === "telegram" ? "telegram" : "whatsapp";
};

export const ChannelIcon = ({ channel, size = 16 }) => {
  const classes = useStyles();
  const telegram = channel === "telegram";
  const Icon = telegram ? TelegramIcon : WhatsAppIcon;
  const color = telegram ? "#229ED9" : "#25D366";
  return (
    <Tooltip title={telegram ? "Telegram" : "WhatsApp"}>
      <span className={classes.icon} style={{ color }}>
        <Icon style={{ fontSize: size, color }} />
      </span>
    </Tooltip>
  );
};

const ChannelConnectionLabel = ({ channel, name, fallback = "-" }) => (
  <span className="channel-hover" style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
    <ChannelIcon channel={channel} />
    {name || fallback}
  </span>
);

export default ChannelConnectionLabel;
